export const TEST_ID = 'subscriptionSummaryCardContainer';
